module.exports = __webpack_public_path__ + "img/whatsapp-icon.aa3a995d8bbcaf07714f09f13ea7a234.svg";